import { getStructure } from './Structure.selector';
import { NormalizedGroup } from '../GroupsAdapter';
import { RootState } from '../../store.model';

export const getGroupsByLevel = (
  state: RootState,
  props: { workspaceId: string | undefined; level: string }
) => {
  const structure = getStructure(state, {
    workspaceId: props.workspaceId,
  });
  const groupIds = structure.data?.levelGroups?.[props.level];
  if (!groupIds) return undefined;
  return groupIds.map(
    (id) => structure.data?.entities.groups[id] as NormalizedGroup
  );
};

export const getHierarchy = (
  state: RootState,
  props: { workspaceId: string | undefined }
) => {
  const structure = getStructure(state, props);
  return structure.data?.hierarchy ?? [];
};
